import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

import { META_TITLE_END } from "../services/lib/metaTags.js";
import { useDispatch, useSelector } from "react-redux";


import Separator from "../component/ui/Separator.js";
import ProfileDetails from "../component/profile/ProfileDetails.js";


function Profile() {
  const { name, avatar, uid, favorites } = useSelector(state => state.user);

  const dispatch = useDispatch();

 

  return (
    <>
      {/* Meta data */}
      {/* <Helmet>
        <title>{`${name}'s Profile${META_TITLE_END}`}</title>
        <meta
          name="description"
          content="View and modify your profile information, including your personalized watch and like lists. Manage your preferences and keep track of your favorite movies, shows, and people"
        />
        <meta name="robots" content="index,follow" />
      </Helmet> */}

      {/* Content */}
      <ProfileDetails />
 
    </>
  );
}

export default Profile;
